import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-1"}],["path",{"d":"M6 18l12 -12","key":"svg-2"}]]

const IconPercentage = createReactComponent('outline', 'percentage', 'Percentage', __iconNode);

export default IconPercentage;